import { maxLength } from 'utils/validators';
import { StyledField, StyledGrid, StyledLabel } from '../ui';
import { FormInput } from 'components';

const validation = maxLength(50);

export const StockField = () => {
  return (
    <StyledGrid item xs={12}>
      <StyledLabel>Stock#</StyledLabel>
      <StyledField
        name="stock"
        // @ts-ignore
        component={FormInput}
        placeholder=""
        disableUnderline
        validate={validation}
      />
    </StyledGrid>
  );
};
